import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deletePharmacist } from '@/features/internal/pharmacist/apis/pharmacist'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'

export const useDeletePharmacistMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => deletePharmacist(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.pharmacy.pharmacists(),
      })
    },
  })
}
